import type { ReactNode } from "react";
import type { PlanStep } from "../../../../skills/leadcue-reply/scripts/lib/work-plan.ts";
import type { DraftRevision } from "../../src/mail-content.ts";
import { EditIcon } from "../icons.tsx";
import { type ReplyBoxLink, useBoxContent } from "../inbox-v2/reply-box-link.ts";

/**
 * The agent reports state; the persistent composer owns the single draft entry and Send. The
 * agent's quiet actions (`agent-quiet.tsx`) end the same line, so a healthy draft is one line.
 */
export function InboxDraftLine(props: {
  draft: DraftRevision | undefined;
  link: ReplyBoxLink;
  actions?: ReactNode;
}) {
  const content = useBoxContent(props.link);
  const loaded =
    content.open && content.loaded === props.draft?.revision && content.text.trim() !== "";
  if (!props.draft) return null;
  return (
    <div className="lcr-agent-draft-line">
      <EditIcon size={16} />
      <span role="status">{loaded ? "Draft open in your reply box" : "Draft ready"}</span>
      {props.actions}
    </div>
  );
}

/** Whether a step shows as the one healthy draft line rather than as a card. */
export function showsDraftLine(props: {
  step: PlanStep;
  draft: DraftRevision | undefined;
  link: ReplyBoxLink | null;
  stale: boolean;
  readiness: { materialBlocked: boolean; slotsUnresolved: boolean };
}): boolean {
  return (
    props.link !== null &&
    props.draft !== undefined &&
    props.step.input.kind === "reply" &&
    !props.stale &&
    !props.readiness.materialBlocked &&
    !props.readiness.slotsUnresolved
  );
}

export function compactInboxDraft(props: {
  step: PlanStep;
  draft: DraftRevision | undefined;
  link: ReplyBoxLink | null;
  stale: boolean;
  readiness: { materialBlocked: boolean; slotsUnresolved: boolean };
  actions?: ReactNode;
}): ReactNode {
  if (!showsDraftLine(props) || !props.link) return null;
  return (
    <InboxDraftLine
      key={props.step.id}
      draft={props.draft}
      link={props.link}
      actions={props.actions}
    />
  );
}
